'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text) {
  if (!text || !text.match(_atSigns2.default)) {
    return [];
  }

  var possibleNames = [];

  text.replace(_validMentionOrList2.default, function (match, before, atSign, screenName, slashListname, offset, chunk) {
    var after = chunk.slice(offset + match.length);
    if (!after.match(_endMentionMatch2.default)) {
      slashListname = slashListname || '';
      var startPosition = offset + before.length;
      var endPosition = startPosition + screenName.length + slashListname.length + 1;
      possibleNames.push({
        screenName: screenName,
        listSlug: slashListname,
        indices: [startPosition, endPosition]
      });
    }
  });

  return possibleNames;
};

var _atSigns = require('./regexp/atSigns');

var _atSigns2 = _interopRequireDefault(_atSigns);

var _endMentionMatch = require('./regexp/endMentionMatch');

var _endMentionMatch2 = _interopRequireDefault(_endMentionMatch);

var _validMentionOrList = require('./regexp/validMentionOrList');

var _validMentionOrList2 = _interopRequireDefault(_validMentionOrList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];